import { uniqueId } from "lodash-es";
import Vue from 'vue';
import { getOffsetRect } from "../../../lib/utils/styling";
import { INJECT_PORTAL_CONTEXT } from './consts';
import { getDefaultPortalContext } from './defaultPortalContext';
const Portal = Vue.extend({
  name: 'Portal',
  props: {
    target: {
      type: String,
      default: 'default'
    }
  },
  created() {
    this.portalId = uniqueId('portal');
    this.actualPortalTarget.addPortal(this);
    this.$watch('actualPortalTarget', (portalTarget, oldPortalTarget) => {
      oldPortalTarget.removePortal(this);
      portalTarget.addPortal(this);
    });
  },
  destroyed() {
    this.actualPortalTarget.removePortal(this);
  },
  render() {
    this.actualPortalTarget.$forceUpdate();
    return null;
  },
  computed: {
    portalContext() {
      return this.defPortalContext || getDefaultPortalContext();
    },
    actualPortalTarget() {
      return this.portalContext.getPortalTarget(this.target);
    },
    actualContainer() {
      return this.actualPortalTarget.$el;
    }
  },
  inject: {
    defPortalContext: {
      from: INJECT_PORTAL_CONTEXT,
      default: null
    }
  },
  methods: {
    /**
     * 传入一个 clientX, clientY 转换为当前 actualContainer 里的对应坐标，
     *
     * 用来做绝对定位很合适
     *
     * @param {number} clientX
     * @param {number} clientY
     * @returns {[number, number]}
     */
    clientToContainerCoordinate(clientX, clientY) {
      const offsetRect = getOffsetRect(new DOMRect(clientX, clientY), this.actualContainer);
      return [offsetRect.left, offsetRect.top];
    },
    /**
     * 获取当前的元素
     */
    getElement() {
      return this.actualPortalTarget.$refs[`portal:${this.portalId}`];
    }
  }
});
export default Portal;